<template>
  <div class="w-100">
    <!-- FULL SCREEN SAVING MODAL -->
    <div
      v-if="loading"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.75); z-index: 9999; display: flex; flex-direction: column; justify-content: center; align-items: center; color: white;"
    >
      <LoadingSpinner style="transform: scale(1.5); margin-bottom: 25px;" />
      <h3 style="color: white; font-weight: bold; margin-top: 15px;">
        Saving, please wait...
      </h3>
    </div>

    <!-- STALE DRAFT MODAL -->
    <div
      v-if="showStaleDraftModal"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 10000; display: flex; justify-content: center; align-items: center;"
    >
      <div style="background: white; padding: 30px; border-radius: 8px; max-width: 450px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
        <i
          class="fas fa-clock"
          style="font-size: 40px; color: #f39c12; margin-bottom: 15px;"
        />
        <h4 style="margin-bottom: 15px; color: #333;">
          Unfinished Draft Found
        </h4>
        <p style="margin-bottom: 25px; color: #666;">
          You started a pet listing over 24 hours ago but didn't finish it. Would you like to continue from where you left off, or delete it and start fresh?
        </p>
        <div style="display: flex; gap: 15px; justify-content: center;">
          <button
            type="button"
            class="btn btn-danger"
            @click="handleDraftDecision('discard')"
          >
            Start Fresh
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleDraftDecision('continue')"
          >
            Continue
          </button>
        </div>
      </div>
    </div>

    <!-- USER DELETE DRAFT CONFIRM MODAL -->
    <div
      v-if="showUserDeleteDraftModal"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 10000; display: flex; justify-content: center; align-items: center;"
    >
      <div style="background: white; padding: 30px; border-radius: 8px; max-width: 400px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
        <i
          class="fas fa-exclamation-triangle"
          style="font-size: 40px; color: #ff4444; margin-bottom: 15px;"
        />
        <h4 style="margin-bottom: 15px; color: #333;">
          Delete Current Draft?
        </h4>
        <p style="margin-bottom: 25px; color: #666;">
          Are you sure you want to delete this draft and start over? All uploaded photos will be removed.
        </p>
        <div style="display: flex; gap: 15px; justify-content: center;">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showUserDeleteDraftModal = false"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="userDeleteDraft"
          >
            Yes, Delete It
          </button>
        </div>
      </div>
    </div>

    <!-- CUSTOM DELETE CONFIRM MODAL -->
    <div
      v-if="showDeleteModal"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 10000; display: flex; justify-content: center; align-items: center;"
    >
      <div style="background: white; padding: 30px; border-radius: 8px; max-width: 400px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
        <i
          class="fas fa-exclamation-triangle"
          style="font-size: 40px; color: #ff4444; margin-bottom: 15px;"
        />
        <h4 style="margin-bottom: 15px; color: #333;">
          Are you sure?
        </h4>
        <p style="margin-bottom: 25px; color: #666;">
          Are you sure you want to delete this image? This action cannot be undone.
        </p>
        <div style="display: flex; gap: 15px; justify-content: center;">
          <button
            type="button"
            class="btn btn-secondary"
            @click="cancelDelete"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="confirmDelete"
          >
            Delete Image
          </button>
        </div>
      </div>
    </div>
    <NavbarTop v-if="showNavbar" />
    <router-view />
    <FooterPage v-if="showFooter" />
    <CookieConsent />
    <div
      v-if="authLoading"
      class="container text-center mt-5"
    >
      <PreLoader />
    </div>
    <div
      v-else
      class="container-fluid mt-5"
    >
      <div
        v-if="auth.currentUser"
        id="petaddlisting"
      >
        <div class="add-listing p-5">
          <div
            class="step-section petlistingbg"
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <h4 style="margin: 0;">
              List to Sell, Buy, Stud or Re-Homing
            </h4>
            <button
              v-if="documentId"
              type="button"
              class="btn btn-outline-danger btn-sm"
              style="border: 1px solid #dc3545; background-color: white;"
              @click.prevent="showUserDeleteDraftModal = true"
            >
              <i class="fas fa-trash-alt" /> Delete Draft & Restart
            </button>
          </div>
          <div class="container-fluid">
            <p>
              Hello {{ userInfo.displayName }} - Your pet ad limit is: {{ adLimit }} ({{
                activeListingsCount
              }}
              currently active, {{ adLeft }} remaining)
            </p>
          </div>
          <div
            v-if="adLeft <= 0"
            class="alert alert-danger"
          >
            You have reached your ad limit. Please archive an active ad to create a new one.
          </div>
          <div v-else>
            <form @submit.prevent="petSubmit">
              <!-- Adım 2: Kategori Seçimi -->
              <div
                v-show="currentStep === 2"
                class="step-section"
              >
                <div
                  v-if="aiCategoryGuess"
                  class="alert alert-info mt-3"
                >
                  <i class="fas fa-magic" /> <strong>AI Suggestion:</strong> Kediniz tahminen {{ aiCategoryGuess }} - {{ aiBreedGuess }} gibi görünüyor. Sizin için kategoriyi seçtim ancak yanılmış olabilirim, lütfen kontrol edip gerekirse düzeltin.
                </div>

                <div class="form-check">
                  Select Category: {{ userInfo.latitude }} - {{ userInfo.longitude }}
                  <span v-if="selectedCategory.id"><small>
                    (ID: {{ selectedCategory.id }}, Name: {{ selectedCategory.name }})</small></span>
                  <span v-else>[Please Select a Main Category]</span>
                  <select
                    id="category"
                    v-model="selectedCategory"
                    class="form-select"
                    required
                    @change="onCategoryChange"
                  >
                    <option
                      :value="{ id: '', name: '' }"
                      disabled
                    >
                      Select a category
                    </option>
                    <option
                      v-for="category in sortedCategories"
                      :key="category.id"
                      :value="{ id: category.id, name: category.name }"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>

                <div class="form-check mt-3">
                  <label for="subCategory">
                    Select Sub Category:
                    <span v-if="selectedSubCategory">{{ selectedSubCategory }}</span>
                    <span v-else>[Seçilmedi]</span>
                  </label>
                  <select
                    id="subCategory"
                    v-model="selectedSubCategory"
                    class="form-select"
                    required
                    @change="createInitialDocument"
                  >
                    <option
                      value=""
                      disabled
                    >
                      Select a sub category
                    </option>
                    <option
                      v-for="subCategory in subCategories"
                      :key="subCategory"
                      :value="subCategory"
                    >
                      {{ subCategory }}
                    </option>
                  </select>
                </div>
                
                <div
                  v-if="categoryCoatPatterns.length > 0"
                  class="form-check mt-3"
                >
                  <label for="coatPattern">
                    Coat Pattern / Marking:
                    <span v-if="coat_pattern">{{ coat_pattern }}</span>
                    <span v-else>[Opsiyonel]</span>
                  </label>
                  <select
                    id="coatPattern"
                    v-model="coat_pattern"
                    class="form-select"
                    @change="saveToLocalStorage"
                  >
                    <option
                      value=""
                      disabled
                    >
                      Select pattern
                    </option>
                    <option
                      v-for="pattern in categoryCoatPatterns"
                      :key="pattern"
                      :value="pattern"
                    >
                      {{ pattern }}
                    </option>
                  </select>
                </div>

                <div
                  v-if="categoryColors.length > 0"
                  class="form-check mt-3"
                >
                  <label for="color">
                    Color:
                    <span v-if="color">{{ color }}</span>
                    <span v-else>[Opsiyonel]</span>
                  </label>
                  <select
                    id="color"
                    v-model="color"
                    class="form-select"
                    @change="saveToLocalStorage"
                  >
                    <option
                      value=""
                      disabled
                    >
                      Select color
                    </option>
                    <option
                      v-for="c in categoryColors"
                      :key="c"
                      :value="c"
                    >
                      {{ c }}
                    </option>
                  </select>
                </div>

                <div class="mt-4">
                  <button
                    type="button"
                    class="btn btn-secondary me-2"
                    @click="prevStep"
                  >
                    Back
                  </button><button
                    type="button"
                    class="btn btn-primary"
                    @click="nextStep"
                  >
                    Next
                  </button>
                </div>
              </div>

              <!-- Adım 1: Resim Yükleme -->
              <div
                v-show="currentStep === 1"
                class="step-section"
              >
                <div
                  class="form-group"
                  style="width: 100%;"
                >
                  <label for="images">Upload Images (Max {{ MAX_IMAGES }}) - Remaining: {{ remainingImages }}:</label>
                  <div>{{ error }}</div>
                  <div style="max-width: 150px; width: 100%; display: flex; flex-direction: column;">
                    <div
                      class="add-list-media-wrap"
                      style="position: relative;"
                    >
                      <!-- AI CHECKING OVERLAY -->
                      <div
                        v-if="isCheckingImages || aiWarningMessage"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.95); z-index: 100; display: flex; flex-direction: column; justify-content: center; align-items: center; border-radius: 5px; text-align: center; padding: 20px;"
                      >
                        <template v-if="isCheckingImages">
                          <LoadingSpinner />
                          <h4 style="margin-top: 15px; color: #333; font-weight: bold;">
                            Checking picture with AI...
                          </h4>
                        </template>
                        <template v-else-if="aiWarningMessage">
                          <i
                            class="fas fa-exclamation-triangle"
                            style="font-size: 45px; color: #e74c3c; margin-bottom: 15px;"
                          />
                          <h4 style="color: #333; font-weight: bold; margin-bottom: 10px;">
                            Image Rejected
                          </h4>
                          <p style="color: #666; margin-bottom: 20px; max-width: 80%;">
                            {{ aiWarningMessage }}
                          </p>
                          <button 
                            type="button"
                            class="btn btn-primary" 
                            style="padding: 10px 25px; border-radius: 5px; font-weight: bold;"
                            @click="aiWarningMessage = null"
                          >
                            Understood
                          </button>
                        </template>
                      </div>

                      <form
                        class="fuzone"
                        style="height: 150px; display: flex; align-items: center; justify-content: center; text-align: center;"
                      >
                        <div class="fu-text">
                          <span><i class="fas fa-image" /> Click to Upload</span>
                          <div class="photoUpload-files fl-wrap" />
                        </div>
                        <input
                          id="images"
                          :disabled="remainingImages <= 0"
                          type="file"
                          multiple
                          accept="image/*"
                          class="form-control"
                          @change="handleImageUpload"
                        >
                      </form>
                    </div>
                  </div>
                </div>

                <div
                  v-if="images.length > 0"
                  class="image-preview"
                >
                  <draggable
                    v-model="images"
                    class="draggable-grid"
                    item-key="url"
                    handle=".drag-handle"
                    @end="handleDragEnd"
                  >
                    <template #item="{ element, index }">
                      <div class="image-item">
                        <div
                          class="image-wrapper"
                          style="position: relative"
                        >
                          <img
                            :src="element.url"
                            alt="Preview"
                            class="drag-handle"
                            style="cursor: grab;"
                          >
                          <button
                            type="button"
                            class="delete-button"
                            :disabled="element.uploading || loading"
                            @click.stop="deleteImage(element, index)"
                          >
                            <i class="fas fa-trash" />
                          </button>
                          <div
                            v-if="element.uploading"
                            class="spinner-overlay"
                          >
                            <LoadingSpinner />
                          </div>
                        </div>
                        <button
                          type="button"
                          class="selection-button"
                          :class="{ 'cover-selected': element.isCover }"
                          @click="setCoverImage(index)"
                        >
                          {{ element.isCover ? 'Cover Image' : 'Set as Cover' }}
                        </button>
                      </div>
                    </template>
                  </draggable>
                </div>
                <div
                  v-if="images.length > 0"
                  class="mt-4"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="analyzingImage || !images.some(img => img.isCover)"
                    @click="nextStep"
                  >
                    {{ analyzingImage ? "Analyzing..." : (!images.some(img => img.isCover) ? "Please select cover image" : "NEXT") }}
                  </button>
                </div>
              </div>

              <!-- Adım 3: Diğer Bilgiler -->
              <div
                v-show="currentStep === 3"
                class="step-section"
              >
                <!-- Mevcut diğer input alanları buraya gelecek -->
                <!-- Diğer Inputlar -->
                <div>
                  <div class="mb-3 petselldetails">
                    <!-- Choose ad type / For sell / Re homing / For Stud -->
                    <h5>Choose ad type</h5>
                    <div class="row">
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="typeForSell"
                            class="form-check-input"
                            type="checkbox"
                            name="adType"
                            value="For Sell"
                            :checked="adType === 'For Sell'"
                            @change="handleAdTypeChange('For Sell')"
                          >
                          <label
                            class="form-check-label"
                            for="typeForSell"
                          > For sell </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="typeForStud"
                            class="form-check-input"
                            type="checkbox"
                            name="adType"
                            value="For Stud"
                            :checked="adType === 'For Stud'"
                            @change="handleAdTypeChange('For Stud')"
                          >
                          <label
                            class="form-check-label"
                            for="typeForStud"
                          > For Stud </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="typeReHoming"
                            class="form-check-input"
                            type="checkbox"
                            name="adType"
                            value="Re Homing"
                            :checked="adType === 'Re Homing'"
                            @change="handleAdTypeChange('Re Homing')"
                          >
                          <label
                            class="form-check-label"
                            for="typeReHoming"
                          > Re-homing </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- age -->
                  <div class="mb-3 p-5">
                    <label for="ageGroup">Age Group:</label>
                    <select
                      id="ageGroup"
                      v-model="ageGroup"
                      class="form-select mb-3"
                      required
                      @change="saveToLocalStorage"
                    >
                      <option
                        value=""
                        disabled
                      >
                        Select age group
                      </option>
                      <option
                        v-for="group in ageGroups"
                        :key="group"
                        :value="group"
                      >
                        {{ group }}
                      </option>
                    </select>

                    <label for="age">Exact Date of Birth (Optional):</label>
                    <input
                      id="age"
                      v-model="birthDate"
                      class="form-control"
                      type="date"
                    >
                  </div>
                  <!-- gender -->
                  <div class="mb-3 petselldetails">
                    <h5>Choose gender</h5>
                    <div class="row">
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="genderMale"
                            class="form-check-input"
                            type="checkbox"
                            name="genderGroup"
                            value="male"
                            :checked="gender === 'male'"
                            @change="handleGenderChange('male')"
                          >
                          <label
                            class="form-check-label"
                            for="genderMale"
                          > Male </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="genderFemale"
                            class="form-check-input"
                            type="checkbox"
                            name="genderGroup"
                            value="female"
                            :checked="gender === 'female'"
                            @change="handleGenderChange('female')"
                          >
                          <label
                            class="form-check-label"
                            for="genderFemale"
                          > Female </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-check">
                          <input
                            id="genderUnknown"
                            class="form-check-input"
                            type="checkbox"
                            name="genderGroup"
                            value="unknown"
                            :checked="gender === 'unknown'"
                            @change="handleGenderChange('unknown')"
                          >
                          <label
                            class="form-check-label"
                            for="genderUnknown"
                          >
                            I don't know / Mixed Litter
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                    class="container p-5"
                  >
                    <!-- Neutered, Microchipped, Vaccinated, Worm Treated, Health Checked -->
                    <div class="mb-3">
                      <h5>Additional Information</h5>
                      <div class="petselldetails">
                        <!-- Neutered -->
                        <div class="col">
                          <label>Neutered:</label>
                          <div class="form-check">
                            <input
                              id="neuteredNo"
                              v-model="isNeutered"
                              class="form-check-input"
                              type="checkbox"
                              value="0"
                              true-value="false"
                              false-value="true"
                            >
                            <label
                              class="form-check-label"
                              for="neuteredNo"
                            >No</label>
                          </div>
                          <div class="form-check">
                            <input
                              id="neuteredYes"
                              v-model="isNeutered"
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              true-value="true"
                              false-value="false"
                            >
                            <label
                              class="form-check-label"
                              for="neuteredYes"
                            >Yes</label>
                          </div>
                        </div>

                        <!-- Microchipped -->
                        <div class="col">
                          <label>Microchipped:</label>
                          <div class="form-check">
                            <input
                              id="microchippedNo"
                              v-model="isMicrochipped"
                              class="form-check-input"
                              type="checkbox"
                              value="0"
                              true-value="false"
                              false-value="true"
                            >
                            <label
                              class="form-check-label"
                              for="microchippedNo"
                            >No</label>
                          </div>
                          <div class="form-check">
                            <input
                              id="microchippedYes"
                              v-model="isMicrochipped"
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              true-value="true"
                              false-value="false"
                            >
                            <label
                              class="form-check-label"
                              for="microchippedYes"
                            >Yes</label>
                          </div>
                        </div>

                        <!-- Vaccinated -->
                        <div class="col">
                          <label>Vaccinated:</label>
                          <div class="form-check">
                            <input
                              id="vaccinatedNo"
                              v-model="isVaccinated"
                              class="form-check-input"
                              type="checkbox"
                              value="0"
                              true-value="false"
                              false-value="true"
                            >
                            <label
                              class="form-check-label"
                              for="vaccinatedNo"
                            >No</label>
                          </div>
                          <div class="form-check">
                            <input
                              id="vaccinatedYes"
                              v-model="isVaccinated"
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              true-value="true"
                              false-value="false"
                            >
                            <label
                              class="form-check-label"
                              for="vaccinatedYes"
                            >Yes</label>
                          </div>
                        </div>

                        <!-- Worm Treated -->
                        <div class="col">
                          <label>Worm Treated:</label>
                          <div class="form-check">
                            <input
                              id="wormTreatedNo"
                              v-model="isWormTreated"
                              class="form-check-input"
                              type="checkbox"
                              value="0"
                              true-value="false"
                              false-value="true"
                            >
                            <label
                              class="form-check-label"
                              for="wormTreatedNo"
                            >No</label>
                          </div>
                          <div class="form-check">
                            <input
                              id="wormTreatedYes"
                              v-model="isWormTreated"
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              true-value="true"
                              false-value="false"
                            >
                            <label
                              class="form-check-label"
                              for="wormTreatedYes"
                            >Yes</label>
                          </div>
                        </div>

                        <!-- Health Checked -->
                        <div class="col">
                          <label>Health Checked:</label>
                          <div class="form-check">
                            <input
                              id="healthCheckedNo"
                              v-model="isHealthChecked"
                              class="form-check-input"
                              type="checkbox"
                              value="0"
                              true-value="false"
                              false-value="true"
                            >
                            <label
                              class="form-check-label"
                              for="healthCheckedNo"
                            >No</label>
                          </div>
                          <div class="form-check">
                            <input
                              id="healthCheckedYes"
                              v-model="isHealthChecked"
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              true-value="true"
                              false-value="false"
                            >
                            <label
                              class="form-check-label"
                              for="healthCheckedYes"
                            >Yes</label>
                          </div>
                        </div>
                      </div>
                      <!-- Row end -->
                    </div>
                    <div
                      v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                    >
                      <label for="bloodType">Select Blood Type:</label>
                      <select
                        id="bloodType"
                        v-model="bloodType"
                        class="form-select"
                        required
                      >
                        <option
                          value=""
                          disabled
                        >
                          Select a blood type
                        </option>
                        <option
                          v-for="type in bloodTypes"
                          :key="type"
                          :value="type"
                        >
                          {{ type }}
                        </option>
                        <option value="I don't know">
                          I don't know
                        </option>
                        <!-- Kullanıcı bilmiyorsa bu seçeneği seçebilir -->
                      </select>
                    </div>
                    <div
                      v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                    >
                      <label for="certificate">Select certificate:</label>
                      <select
                        id="certificate"
                        v-model="certificate"
                        class="form-select"
                        required
                      >
                        <option
                          value=""
                          disabled
                        >
                          Select certificate
                        </option>
                        <option
                          v-for="type in certificates"
                          :key="type"
                          :value="type"
                        >
                          {{ type }}
                        </option>
                        <option value="No certificate">
                          No certificate
                        </option>
                        <!-- Kullanıcı bilmiyorsa bu seçeneği seçebilir -->
                      </select>
                    </div>
                  </div>
                </div>
                <div class="mt-4">
                  <button
                    type="button"
                    class="btn btn-secondary me-2"
                    @click="prevStep"
                  >
                    Back
                  </button><button
                    type="button"
                    class="btn btn-primary"
                    :disabled="generatingText"
                    @click="nextStep"
                  >
                    {{ generatingText ? "Generating AI Text..." : "Next" }}
                  </button>
                </div>
              </div>

              <!-- Adım 4: Title / Description / Price -->
              <div
                v-show="currentStep === 4"
                class="step-section"
              >
                <div class="p-5">
                  <div class="form-check">
                    <div
                      v-if="generatedTitles.length > 0"
                      class="mb-4 p-4 border rounded bg-light"
                    >
                      <h5 class="text-primary">
                        <i class="fas fa-magic" /> AI Suggested Texts
                      </h5>
                      <p>Click on any suggestion to apply it.</p>
                      
                      <h6>Titles:</h6>
                      <div class="d-flex flex-wrap gap-2 mb-3">
                        <button
                          v-for="t in generatedTitles"
                          :key="t"
                          type="button"
                          class="btn btn-outline-primary btn-sm"
                          @click="title = t"
                        >
                          {{ t }}
                        </button>
                      </div>

                      <h6>Descriptions:</h6>
                      <div class="d-flex flex-column gap-2 mb-3">
                        <button
                          v-for="d in generatedDescriptions"
                          :key="d"
                          type="button"
                          class="btn btn-outline-secondary btn-sm text-start"
                          @click="description = d"
                        >
                          {{ d.substring(0, 80) }}...
                        </button>
                      </div>
                    </div>

                    <label
                      class="form-check-label"
                      for="title"
                    >Title:</label>
                    <input
                      id="title"
                      v-model="title"
                      class="form-control"
                      type="text"
                      required
                    >
                  </div>
                  <div class="form-check">
                    <label
                      class="form-check-label"
                      for="description"
                    >Description:</label>
                    <textarea
                      id="description"
                      v-model="description"
                      class="form-control"
                      rows="18"
                      required
                    />
                  </div>
                  <div class="form-check">
                    <label
                      class="form-check-label"
                      for="price"
                    >Price:</label>
                    <input
                      id="price"
                      v-model="price"
                      class="form-control"
                      type="number"
                      required
                    >
                  </div>
                </div>
                <!-- ---END--- Title / Description / Price  -->
                <div class="p-5">
                  <p
                    v-if="!images.length"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please load images
                  </p>
                  <p
                    v-if="coverImageIndex === null"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please select a cover image
                  </p>
                  <p
                    v-if="title === ''"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please write title
                  </p>
                  <p
                    v-if="description === ''"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please write description
                  </p>
                  <p
                    v-if="images.length && coverImageIndex !== null"
                    class="p-2 bg-light border"
                    style="color: green"
                  >
                    Images Ready!
                  </p>
                  <p
                    v-if="!birthDate"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please choose birth date
                  </p>
                  <div class="d-flex justify-content-between mt-3 mb-5">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="prevStep"
                    >
                      BACK
                    </button>
                    <button
                      class="btn btn-primary"
                      type="submit"
                      :disabled="
                        loading ||
                          !images.length ||
                          !birthDate ||
                          coverImageIndex === null ||
                          title === '' ||
                          description === '' ||
                          images.some((image) => image.uploading)
                      "
                    >
                      {{ loading ? 'Saving...' : 'Save Listing' }}
                    </button>
                  </div>

                  <div
                    v-if="error"
                    class="error"
                  >
                    {{ error }}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, watch } from 'vue';
  import { getFunctions, httpsCallable } from 'firebase/functions';
  import { getAuth, onAuthStateChanged } from 'firebase/auth';
  import {
    arrayUnion,
    arrayRemove,
    collection,
    serverTimestamp,
    doc,
    query,
    where,
    getDocs,
    getDoc,
    GeoPoint,
    deleteField,
    deleteDoc,
  } from 'firebase/firestore';
  import {
    getStorage,
    ref as storageRef,
    uploadBytesResumable,
    getDownloadURL,
    deleteObject,
  } from 'firebase/storage';
  import { db } from '@/firebase'; 
  import { createPetListing, updatePetListing, getPetListingById, getActiveListingsCount, getPetDraft } from '@/services/petService';
  import { useRouter, useRoute } from 'vue-router';
  import LoadingSpinner from './LoadingSpinner.vue';
  import { reactive } from 'vue';
  import PreLoader from './PreLoader.vue';
  import draggable from 'vuedraggable';
  import { useDeviceStore } from '@/stores/deviceStore';
  import { compressImage } from '@/utils/imageUtils';

  import NavbarTop from '@/components/NavbarTop.vue';
  import FooterPage from '@/components/FooterPage.vue';
  import CookieConsent from '@/components/CookieConsent.vue';

  const showNavbar = ref(false);
  const showFooter = ref(false);
  const deviceStore = useDeviceStore();

  const title = ref('');
  const description = ref('');
  const price = ref(0);
  const images = ref([]);
  const coverImageIndex = ref(null);
  const error = ref(null);
  const loading = ref(false);
  const router = useRouter();
  const route = useRoute();
  const auth = getAuth();
  const storage = getStorage();
  const userInfo = ref(null);
  const isNeutered = ref(false); // Varsayılan olarak "No" seçili
  const isMicrochipped = ref(false);
  const isVaccinated = ref(false);
  const isWormTreated = ref(false);
  const isHealthChecked = ref(false);
  const gender = ref('unknown'); // Gender seçimi için yeni data özelliği
  const adType = ref('Re Homing'); // Ad type seçimi için yeni data özelliği
  // Kategori ve Alt Kategori İşlemleri
  const categories = ref([]);
  const selectedCategory = ref({ id: '', name: '' }); // Hem ID hem de ismi tutalım
  const subCategories = ref([]);
  const selectedSubCategory = ref('');
  const bloodType = ref(''); // Kullanıcının seçtiği kan grubu
  const birthDate = ref(''); // Doğum tarihi
  const ageGroup = ref('');
  const coat_pattern = ref('');
  const color = ref('');
  const categoryCoatPatterns = ref([]);
  const categoryColors = ref([]);
  const ageGroups = ['0-3 Months', '3-6 Months', '6-12 Months', '1-2 Years', '2-4 Years', '4-8 Years', '8+ Years'];
  const certificate = ref(''); // Sertifikalar
  const isInitialLoad = ref(true); // <--- BU SATIRI EKLEYİN

  const showStaleDraftModal = ref(false);
  const draftDecisionPromise = ref(null);
  const showUserDeleteDraftModal = ref(false);

  const askUserDraftDecision = () => {
    showStaleDraftModal.value = true;
    return new Promise((resolve) => {
      draftDecisionPromise.value = resolve;
    });
  };

  const handleDraftDecision = (decision) => {
    showStaleDraftModal.value = false;
    if (draftDecisionPromise.value) {
      draftDecisionPromise.value(decision);
      draftDecisionPromise.value = null;
    }
  };

  const userDeleteDraft = async () => {
    showUserDeleteDraftModal.value = false;
    loading.value = true;
    try {
      if (documentId.value) {
        // Find current images to delete
        const allImages = [...images.value.map(i => i.uploadUrl), ...images.value.map(i => i.thumbnailUrl)].filter(Boolean);
        for (const url of allImages) {
          await deleteImageFromStorage(url).catch(console.error);
        }
        await deleteDoc(doc(db, 'pets', documentId.value)).catch(console.error);
      }
      localStorage.removeItem(`petform_${auth.currentUser.uid}`);
      
      // Reload page to reset form state completely
      window.location.reload();
    } catch (err) {
      console.error("Error deleting draft:", err);
      error.value = 'Could not delete draft: ' + err.message;
    } finally {
      loading.value = false;
    }
  };

  const showDeleteModal = ref(false);
  const imageToDelete = ref(null);
  const indexToDelete = ref(null);

  const deleteImage = (imageObj, index) => {
    imageToDelete.value = imageObj;
    indexToDelete.value = index;
    showDeleteModal.value = true;
  };

  const cancelDelete = () => {
    showDeleteModal.value = false;
    imageToDelete.value = null;
    indexToDelete.value = null;
  };

  const confirmDelete = async () => {
    showDeleteModal.value = false;
    const imageObj = imageToDelete.value;
    const index = indexToDelete.value;
    
    if (!imageObj) return;

    try {
      loading.value = true;
      error.value = null;

      // İlan sahibi olup olmadığını kontrol et
      if (auth.currentUser.uid !== (await checkListingOwner())) {
        error.value = 'You are not authorized to delete this image.';
        loading.value = false;
        return;
      }

      // Firestore'dan kaldır
      const updateData = {};

      if (imageObj.uploadUrl) {
        updateData.images = arrayRemove(imageObj.uploadUrl);
        
        // Eğer AI tahmini varsa onu da DB'den sil
        if (imageObj.aiSuggestion) {
          updateData.aiSuggestions = arrayRemove({
            url: imageObj.uploadUrl,
            category: imageObj.aiSuggestion.category || '',
            subCategory: imageObj.aiSuggestion.subCategory || '',
            coatPattern: imageObj.aiSuggestion.coatPattern || '',
            color: imageObj.aiSuggestion.color || '',
            ageGroup: imageObj.aiSuggestion.ageGroup || ''
          });
        }
      }

      if (imageObj.thumbnailUrl) {
        updateData.thumbnails = arrayRemove(imageObj.thumbnailUrl);
      }

      if (imageObj.isCover) {
        updateData.coverImage = deleteField();
        updateData.coverThumbnail = deleteField();
      }

      if (Object.keys(updateData).length > 0 && documentId.value) {
        await updatePetListing(documentId.value, updateData);
      }

      // Diziden kaldır
      images.value.splice(index, 1);

      // Cover image güncellemeleri
      if (imageObj.isCover) {
        coverImageIndex.value = null;
      } else if (coverImageIndex.value !== null && coverImageIndex.value > index) {
        coverImageIndex.value--;
      }

      // Storage'dan sil (Arka planda)
      if (imageObj.uploadUrl) {
        deleteImageFromStorage(imageObj.uploadUrl).catch(console.error);
      }
      if (imageObj.thumbnailUrl) {
        deleteImageFromStorage(imageObj.thumbnailUrl).catch(console.error);
      }
    } catch (err) {
      console.error('Silme hatası:', err);
      error.value = 'Resim silinemedi: ' + err.message;
    } finally {
      loading.value = false;
      imageToDelete.value = null;
      indexToDelete.value = null;
    }
  };

  // AI & Navigation State
  const functions = getFunctions();
  const analyzePetImageFn = httpsCallable(functions, 'analyzePetImage');
  const generatePetListingTextFn = httpsCallable(functions, 'generatePetListingText');
  const analyzingImage = ref(false);
  const isCheckingImages = computed(() => images.value.some(img => img.uploading));
  const aiWarningMessage = ref(null);
  const generatingText = ref(false);
  const generatedTitles = ref([]);
  const generatedDescriptions = ref([]);
  const aiCategoryGuess = ref('');
  const aiBreedGuess = ref('');

  const nextStep = async () => {
    if (currentStep.value === 1) {
      if (images.value.length === 0) {
        error.value = "Lütfen en az 1 resim yükleyin.";
        return;
      }
      await runImageAnalysis();
      currentStep.value = 2;
    } else if (currentStep.value === 2) {
      if (!selectedCategory.value?.name || !selectedSubCategory.value) {
        error.value = "Lütfen kategori ve alt kategori seçiniz.";
        return;
      }
      
      // Kategori ve alt kategoriyi DB'ye kaydet
      if (documentId.value) {
        updatePetListing(documentId.value, {
          category: selectedCategory.value.name,
          categoryId: selectedCategory.value.id,
          subCategory: selectedSubCategory.value
        }).catch(err => console.error("Kategori güncellenemedi:", err));
      }
      
      currentStep.value = 3;
    } else if (currentStep.value === 3) {
      await runTextGeneration();
      currentStep.value = 4;
    }
  };

  const prevStep = () => {
    if (currentStep.value > 1) {
      currentStep.value--;
      error.value = null;
    }
  };

  const runImageAnalysis = async () => {
    analyzingImage.value = true;
    error.value = null;
    
    try {
      if (!documentId.value) {
        analyzingImage.value = false;
        return;
      }
      
      // Her zaman güncel veriyi veritabanından çek (Cihaz hafızasına güvenme)
      const docSnap = await getPetListingById(documentId.value);
      if (!docSnap.exists()) {
        analyzingImage.value = false;
        return;
      }
      
      const data = docSnap.data();
      const dbSuggestions = data.aiSuggestions || [];
      
      const suggestions = dbSuggestions
        .filter(s => s && s.category && s.subCategory);
        
      if (suggestions.length === 0) {
        analyzingImage.value = false;
        return;
      }
      
      // Çoğunluğu (mode) bulma
      const frequencyMap = {};
      let maxFreq = 0;
      let majoritySuggestion = null;
      
      suggestions.forEach(s => {
        const key = `${s.category}|${s.subCategory}|${s.coatPattern}|${s.color}|${s.ageGroup}`;
        frequencyMap[key] = (frequencyMap[key] || 0) + 1;
        if (frequencyMap[key] > maxFreq) {
          maxFreq = frequencyMap[key];
          majoritySuggestion = s;
        }
      });
      
      if (majoritySuggestion) {
        aiCategoryGuess.value = majoritySuggestion.category;
        aiBreedGuess.value = majoritySuggestion.subCategory;
        const aiCoatPattern = majoritySuggestion.coatPattern;
        const aiColor = majoritySuggestion.color;
        const aiAgeGroup = majoritySuggestion.ageGroup;
        
        // Auto-select
        const foundCat = categories.value.find(c => c.name === majoritySuggestion.category);
        if (foundCat) {
          selectedCategory.value = { id: foundCat.id, name: foundCat.name };
          await fetchSubCategories();
          if (subCategories.value.includes(majoritySuggestion.subCategory)) {
            selectedSubCategory.value = majoritySuggestion.subCategory;
          }
          if (aiCoatPattern && categoryCoatPatterns.value.includes(aiCoatPattern)) {
            coat_pattern.value = aiCoatPattern;
          }
          if (aiColor && categoryColors.value.includes(aiColor)) {
            color.value = aiColor;
          }
          if (aiAgeGroup && ageGroups.includes(aiAgeGroup)) {
            ageGroup.value = aiAgeGroup;
          }
        }
      }
    } catch (err) {
      console.error("Aggregation error:", err);
    } finally {
      analyzingImage.value = false;
    }
  };

  const runTextGeneration = async () => {
    generatingText.value = true;
    error.value = null;
    try {
      const result = await generatePetListingTextFn({
        category: selectedCategory.value.name,
        subCategory: selectedSubCategory.value,
        ageGroup: ageGroup.value,
        coat_pattern: coat_pattern.value,
        color: color.value,
        age: birthDate.value,
        gender: gender.value,
        isVaccinated: isVaccinated.value,
        isMicrochipped: isMicrochipped.value,
        isNeutered: isNeutered.value,
        isHealthChecked: isHealthChecked.value,
        isWormTreated: isWormTreated.value,
        adType: adType.value
      });

      generatedTitles.value = result.data.titles || [];
      generatedDescriptions.value = result.data.descriptions || [];
    } catch (err) {
      console.error("AI Generation failed:", err);
    } finally {
      generatingText.value = false;
    }
  };
  
  // Kullanıcı ilanlarını getirme fonksiyonu
  const activeListingsCount = ref(0);

  // adLimit computed property
  const adLimit = computed(() => {
    return userInfo.value?.account?.properties?.ad_limit || 3; // Varsayılan limit 3
  });
  const adLeft = computed(() => {
    return adLimit.value - activeListingsCount.value;
  });
  // Draft ilanları yükleyen fonksiyon
  const MAX_IMAGES = 20; // Maksimum resim sayısı

  const debounce = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  };

  const remainingImages = computed(() => {
    return MAX_IMAGES - images.value.length;
  });

  const sortedCategories = computed(() => {
    return categories.value.slice().sort((a, b) => a.order - b.order);
  });

  const bloodTypes = computed(() => {
    if (selectedCategory.value.name === 'Cats') {
      return ['A', 'B', 'AB']; // Kediler için kan grupları
    } else if (selectedCategory.value.name === 'Dogs') {
      return [
        'DEA 1.1+',
        'DEA 1.1-',
        'DEA 1.2',
        'DEA 3',
        'DEA 4',
        'DEA 5',
        'DEA 6',
        'DEA 7',
        'DEA 8',
      ]; // Köpekler için kan grupları
    }
    return [];
  });

  const certificates = computed(() => {
    if (selectedCategory.value.name === 'Dogs') {
      return [
        'Pedigree',
        'Federation Cynologique Internationale (FCI)',
        'American Kennel Club (AKC)',
        'United Kennel Club (UKC)',
        'Kennel Club of the United Kingdom (KC)',
        'Australian National Kennel Council (ANKC)',
        'Canadian Kennel Club (CKC)',
        'New Zealand Kennel Club (NZKC)',
        'Irish Kennel Club (IKC)',
        'The Kennel Club (KC)',
      ]; // Köpekler için sertifikalar
    } else if (selectedCategory.value.name === 'Cats') {
      return [
        'The International Cat Association (TICA)',
        'The Cat Fanciers’ Association (CFA)',
        'The Governing Council of the Cat Fancy (GCCF)',
        'Fédération Internationale Féline (FIFe)',
        'Australian Cat Federation (ACF)',
        'Canadian Cat Association (CCA-AFC)',
        'New Zealand Cat Fancy (NZCF)',
        'Southern Africa Cat Council (SACC)',
        'Cat Fanciers’ Federation (CFF)',
        'American Cat Fanciers Association (ACFA)',
      ]; // Kediler için sertifikalar
    }
    return [];
  });

  // LocalStorage işlemleri
  const saveToLocalStorage = debounce(() => {
    const formData = {
      adType: adType.value,
      title: title.value,
      description: description.value,
      price: price.value,
      birthDate: birthDate.value,
      ageGroup: ageGroup.value,
      coat_pattern: coat_pattern.value,
      color: color.value,
      gender: gender.value,
      bloodType: bloodType.value,
      certificate: certificate.value,
      documentId: documentId.value,
      isNeutered: isNeutered.value,
      isMicrochipped: isMicrochipped.value,
      isVaccinated: isVaccinated.value,
      isWormTreated: isWormTreated.value,
      isHealthChecked: isHealthChecked.value,
      coverImageIndex: coverImageIndex.value,
      images: images.value.map((img) => ({
        url: img.uploadUrl,
        thumbnailUrl: img.thumbnailUrl,
        isCover: img.isCover,
        aiSuggestion: img.aiSuggestion || null,
      })),
    };
    localStorage.setItem(`petform_${auth.currentUser.uid}`, JSON.stringify(formData));
  }, 500);

  watch(
    [
      title,
      description,
      price,
      birthDate,
      ageGroup,
      coat_pattern,
      color,
      gender,
      bloodType,
      certificate,
      isNeutered,
      isMicrochipped,
      isVaccinated,
      isWormTreated,
      isHealthChecked,
      selectedCategory,
      selectedSubCategory,
      coverImageIndex,
      adType,
    ],
    () => {
      if (auth.currentUser) {
        saveToLocalStorage();
      }
    },
  );

  onMounted(async () => {
    try {
      const fetchActiveListingsCount = async (userId) => {
        try {
          activeListingsCount.value = await getActiveListingsCount(userId);
        } catch (error) {
          console.error('Error fetching active listings:', error);
        }
      };

      // Device detection
      deviceStore.detectDevice();

      const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        if (currentUser) {
          try {
            // 1. Kullanıcı bilgilerini yükle
            const userDocRef = doc(db, 'users', currentUser.uid);
            const userDocSnap = await getDoc(userDocRef);

            const propertiesDocRef = doc(db, 'users', currentUser.uid, 'account', 'properties');
            const propertiesDocSnap = await getDoc(propertiesDocRef);

            if (userDocSnap.exists()) {
              userInfo.value = userDocSnap.data();
              if (propertiesDocSnap.exists()) {
                userInfo.value.account = userInfo.value.account || {};
                userInfo.value.account.properties = propertiesDocSnap.data();
              }
              // Aktif ilanları getir
              await fetchActiveListingsCount(currentUser.uid);
            }

            // 2. Kategorileri yükle
            const categoriesSnapshot = await getDocs(collection(db, 'petcategories'));
            categories.value = categoriesSnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));

            // 3. Draft yükle
            await loadDraftDocument(currentUser.uid);
          } catch (error) {
            console.error('Veri yükleme hatası:', error);
          }
        }
        authLoading.value = false;
      });

      // Cleanup function
      return () => unsubscribe();
    } catch (error) {
      console.error('Mount hatası:', error);
      authLoading.value = false;
    }
  });

  // Kategori seçimi değiştiğinde alt kategorileri çek
  const onCategoryChange = async () => {
    if (selectedCategory.value.id) {
      await fetchSubCategories();
    } else {
      subCategories.value = [];
    }
  };

  // Seçilen kategoriye göre alt kategorileri çek
  const fetchSubCategories = async () => {
    //console.log("Alt kategoriler çekiliyor...");
    if (!selectedCategory.value?.id) {
      console.warn('Kategori seçili değil, alt kategoriler temizlendi');
      subCategories.value = [];
      categoryCoatPatterns.value = [];
      categoryColors.value = [];
      return;
    }

    try {
      const categoryDoc = await getDoc(doc(db, 'petcategories', selectedCategory.value.id));
      if (categoryDoc.exists()) {
        const data = categoryDoc.data();
        subCategories.value = data.subcategories || [];
        categoryCoatPatterns.value = data.coat_patterns || [];
        categoryColors.value = data.colors || [];
        //console.log("Alt kategoriler alındı:", subCategories.value);
      } else {
        console.error('Kategori dökümanı bulunamadı!');
        subCategories.value = [];
        categoryCoatPatterns.value = [];
        categoryColors.value = [];
      }
    } catch (error) {
      console.error('Alt kategori çekme hatası:', error);
      subCategories.value = [];
      categoryCoatPatterns.value = [];
      categoryColors.value = [];
    }
  };

  const loadDraftDocument = async (userId) => {
    try {
      // Önce localStorage'dan kontrol et
      const localData = localStorage.getItem(`petform_${userId}`);
      let parsedLocalData = localData ? JSON.parse(localData) : null;
      //console.log("Draft ilan yükleniyor...");
      let draftSnapshot;
      if (route.query.id) {
        const docSnap = await getPetListingById(route.query.id);
        if (docSnap.exists() && docSnap.data().createdBy === userId) {
          draftSnapshot = { empty: false, docs: [docSnap] };
        } else {
          draftSnapshot = { empty: true };
        }
      } else {
        draftSnapshot = await getPetDraft(userId);
      }

      if (!draftSnapshot.empty) {
        const draftDoc = draftSnapshot.docs[0];
        documentId.value = draftDoc.id;
        
        // Eğer localStorage'dan gelen verinin documentId'si şu anki ile eşleşmiyorsa, onu kullanma!
        if (parsedLocalData && parsedLocalData.documentId !== documentId.value) {
          parsedLocalData = null;
        }

        const data = draftDoc.data();
        
        let isStale = false;
        if (data.createdAt) {
          const createdAtDate = data.createdAt.toDate ? data.createdAt.toDate() : new Date(data.createdAt);
          if (Date.now() - createdAtDate.getTime() > 24 * 60 * 60 * 1000) {
            isStale = true;
          }
        }
        
        if (isStale) {
          const decision = await askUserDraftDecision();
          if (decision === 'discard') {
            if (data.images && data.images.length > 0) {
              for (const imgUrl of data.images) {
                await deleteImageFromStorage(imgUrl).catch(console.error);
              }
            }
            if (data.thumbnails && data.thumbnails.length > 0) {
              for (const thumbUrl of data.thumbnails) {
                await deleteImageFromStorage(thumbUrl).catch(console.error);
              }
            }
            await deleteDoc(doc(db, 'pets', draftDoc.id)).catch(console.error);
            localStorage.removeItem(`petform_${userId}`);
            documentId.value = null;
            return;
          }
        }

        //console.log("Firestore'dan gelen draft verisi:", data);

        // 1. Kategoriyi bul
        if (data.categoryId) {
          //console.log("Aranan categoryId:", data.categoryId);
          const foundCategory = categories.value.find((cat) => cat.id === data.categoryId);
          //console.log("Bulunan kategori:", foundCategory);

          if (foundCategory) {
            // 2. Kategori değişimini izleme devre dışı
            isInitialLoad.value = true;

            // 3. Kategoriyi reactive objeye ata
            selectedCategory.value = {
              id: foundCategory.id,
              name: foundCategory.name,
            };
            //console.log("Kategori atandı:", selectedCategory.value);

            // 4. Alt kategorileri yükle
            await fetchSubCategories();
            //console.log("Alt kategoriler yüklendi:", subCategories.value);

            // 5. Alt kategoriyi seç (yüklendikten sonra)
            if (data.subCategory) {
              selectedSubCategory.value = data.subCategory;
              //console.log("Alt kategori atandı:", selectedSubCategory.value);
            }

            // 6. Watch'ı yeniden etkinleştir
            isInitialLoad.value = false;
          }
        } else {
          //console.error("Draft ilanda categoryId bulunamadı!");
        }

        // Diğer alanları yükle
        adType.value = parsedLocalData?.adType || data.adType || 'reHoming';
        title.value = parsedLocalData?.title || data.title || '';
        description.value = parsedLocalData?.description || data.description || '';
        price.value = parsedLocalData?.price || data.price || 0;
        birthDate.value = parsedLocalData?.birthDate || data.birthDate || '';
        ageGroup.value = parsedLocalData?.ageGroup || data.ageGroup || '';
        coat_pattern.value = parsedLocalData?.coat_pattern || data.coat_pattern || '';
        color.value = parsedLocalData?.color || data.color || '';
        gender.value = parsedLocalData?.gender || data.gender || 'unknown';
        coverImageIndex.value = parsedLocalData?.coverImageIndex || data.coverImageIndex || null;

        bloodType.value = parsedLocalData?.bloodType || data.bloodType || '';
        certificate.value = parsedLocalData?.certificate || data.certificate || '';
        if (selectedCategory.value.name == 'Cats' || selectedCategory.value.name == 'Dogs') {
          isNeutered.value = parsedLocalData?.isNeutered || data.isNeutered || false;
          isMicrochipped.value = parsedLocalData?.isMicrochipped || data.isMicrochipped || false;
          isVaccinated.value = parsedLocalData?.isVaccinated || data.isVaccinated || false;
          isWormTreated.value = parsedLocalData?.isWormTreated || data.isWormTreated || false;
          isHealthChecked.value = parsedLocalData?.isHealthChecked || data.isHealthChecked || false;
        }
        //console.log("Diğer alanlar yüklendi");

        // Resimleri yükle
        if (data.images?.length > 0) {
          data.images.forEach((imgUrl, index) => {
            // Find corresponding AI suggestion from localStorage if available
            const localImg = parsedLocalData?.images?.find(i => i.url === imgUrl);
            // Veya Firestore veritabanından bul
            const dbSuggestion = data.aiSuggestions?.find(s => s.url === imgUrl);
            
            // Firebase DB'deki aiSuggestions array'inden category ve subCategory çıkarıp bizim aiSuggestion formatına çevir
            let formattedDbSuggestion = null;
            if (dbSuggestion) {
              formattedDbSuggestion = {
                category: dbSuggestion.category,
                subCategory: dbSuggestion.subCategory
              };
            }

            images.value.push(
              reactive({
                file: null,
                url: imgUrl,
                isCover: data.coverImage === imgUrl,
                uploading: false,
                uploadUrl: imgUrl,
                uploadError: false,
                aiSuggestion: formattedDbSuggestion || localImg?.aiSuggestion || null,
              }),
            );
            if (data.coverImage === imgUrl) coverImageIndex.value = index;
          });
          //console.log(`${data.images.length} resim yüklendi`);
        }

        // Adım geçişi
        if (selectedCategory.value.id && selectedSubCategory.value) {
          currentStep.value = 2;
          //console.log("Adım 2'ye geçildi");
        }
      } else {
        //console.log("Draft ilan bulunamadı");
      }
    } catch (err) {
      //console.error("Draft yüklenirken hata:", err);
    }
  };

  const handleImageUpload = async (event) => {
    error.value = null;
    const files = event.target.files;

    const currentCount = images.value.length;
    const remaining = MAX_IMAGES - currentCount;

    if (files.length > remaining) {
      error.value = `Seçtiğiniz resim sayısı yükleme hakkınızdan fazla. Siz ${files.length} resim seçtiniz, en fazla ${remaining} kadar seçebilirsiniz.`;
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Önce ana resmi oluştur
      const mainImage = await compressImage(
        file,
        selectedSubCategory.value,
        deviceStore.isIOS,
        'image',
      );

      // Ana resmin ismini kullanarak thumbnail oluştur
      const thumbnail = await compressImage(
        file,
        selectedSubCategory.value,
        deviceStore.isIOS,
        'thumbnail',
        mainImage.name, // Ana resmin ismini kullan
      );

      const previewUrl = URL.createObjectURL(mainImage);

      const imageObj = reactive({
        file: mainImage,
        thumbnail: thumbnail, // Thumbnail'i ekle
        url: previewUrl,
        isCover: false,
        uploading: true,
        uploadUrl: null,
        thumbnailUrl: null, // Thumbnail URL için
        uploadError: false,
      });

      images.value.push(imageObj);

      if (!documentId.value) {
        await createInitialDocument();
      }

      if (documentId.value) {
        uploadImageImmediately(mainImage, thumbnail, imageObj);
      } else {
        console.warn('Document ID bulunamadı');
      }
    }
  };

  const setCoverImage = (index) => {
    // Seçilen resmi bul
    const selectedImage = images.value[index];

    // Diğer tüm resimlerin cover'ını false yap
    images.value.forEach((image) => {
      image.isCover = false;
    });

    // Seçilen resmi cover olarak işaretle
    selectedImage.isCover = true;

    // Seçilen resmi diziden çıkar ve başa ekle
    images.value = [selectedImage, ...images.value.filter((_, i) => i !== index)];

    // Cover index'ini güncelle (artık 0. indeks)
    coverImageIndex.value = 0;

    // Eğer documentId varsa Firestore'u güncelle
    if (documentId.value) {
      // Boş değerleri filtrele
      const validImages = images.value
        .map((img) => img.uploadUrl)
        .filter((url) => url !== undefined && url !== null);

      const validThumbnails = images.value
        .map((img) => img.thumbnailUrl)
        .filter((url) => url !== undefined && url !== null);

      // Cover değerleri kontrol et
      const coverImageUrl = selectedImage.uploadUrl || null;
      const coverThumbnailUrl = selectedImage.thumbnailUrl || null;

      // Firestore güncellemesi için veri objesi
      const updateData = {
        images: validImages,
      };

      // Thumbnail'ler varsa ekle
      if (validThumbnails.length > 0) {
        updateData.thumbnails = validThumbnails;
      }

      // Cover image varsa ekle
      if (coverImageUrl) {
        updateData.coverImage = coverImageUrl;
      }

      // Cover thumbnail varsa ekle
      if (coverThumbnailUrl) {
        updateData.coverThumbnail = coverThumbnailUrl;
      }

      updatePetListing(documentId.value, updateData).catch((err) => {
        console.error('Cover image update error:', err);
        error.value = err.message;
      });
    }
  };

  const createSlug = async (titleText, ilanID) => {
    let slug = titleText
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
    let uniqueSlug = slug;
    let counter = 1;

    let querySnapshot = await getDocs(
      query(collection(db, 'pets'), where('slug', '==', uniqueSlug)),
    );

    while (!querySnapshot.empty) {
      uniqueSlug = `${slug}-${counter}`;
      counter++;
      querySnapshot = await getDocs(query(collection(db, 'pets'), where('slug', '==', uniqueSlug)));
    }

    await updatePetListing(ilanID, {
      slug: uniqueSlug,
    });

    return uniqueSlug;
  };

  const uploadImage = async (file, ilanID) => {
    try {
      // Metadata ekle
      const metadata = {
        contentType: file.type,
        cacheControl: 'public, max-age=31536000',
        customMetadata: {
          uploadedBy: auth.currentUser.uid,
          uploadTime: new Date().toISOString(),
        },
      };

      const storageReference = storageRef(storage, `public/adimages/${ilanID}/${file.name}`);

      // uploadBytes yerine uploadBytesResumable kullan
      const uploadTask = uploadBytesResumable(storageReference, file, metadata);

      // Upload tamamlanana kadar bekle
      await uploadTask;

      // URL'i döndür
      return await getDownloadURL(storageReference);
    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    }
  };

  const petSubmit = async () => {
    if (images.value.some((image) => image.uploading)) {
      error.value = 'Lütfen tüm resimler yüklenene kadar bekleyin.';
      return;
    }

    loading.value = true;
    error.value = null;
    try {
      if (!auth.currentUser) {
        throw new Error('You must be logged in to upload images.');
      }
      // GeoPoint oluştur
      const geoPoint = new GeoPoint(
        Number(userInfo.value.latitude),
        Number(userInfo.value.longitude),
      );

      // Cover image'i bul
      const coverImage = images.value.find((img) => img.isCover);

      // Thumbnail kontrolü - BURADA DÜZELTME YAPILDI
      const validThumbnails = [];
      const validImages = [];

      // Öncelikle images.value dizisinden tüm resimleri al
      // localStorage yerine doğrudan images.value'dan yararlan
      images.value.forEach((img) => {
        if (img.uploadUrl) validImages.push(img.uploadUrl);
        if (img.thumbnailUrl) validThumbnails.push(img.thumbnailUrl);
      });

      // Firestore'a gönderilecek veriyi hazırla
      const docData = {
        adType: adType.value,
        title: title.value,
        description: description.value,
        // ÖNEMLİ: Burada direkt validImages ve validThumbnails kullan
        images: validImages,
        thumbnails: validThumbnails,
        coverImage: coverImage?.uploadUrl || null,
        coverThumbnail: coverImage?.thumbnailUrl || null,
        price: Number(price.value),
        createdAt: serverTimestamp(),
        createdBy: auth.currentUser.uid,
        owner: auth.currentUser.email,
        ownerName: auth.currentUser.displayName,
        ownerPhone: userInfo.value.phoneNumber,
        ownerPhotoURL: userInfo.value.photoURL,
        postalTown: userInfo.value.postalTown,
        status: 'active',
        viewed: 0,
        liked: 0,
        adLocation: geoPoint,
        category: selectedCategory.value.name,
        categoryId: selectedCategory.value.id,
        subCategory: selectedSubCategory.value,
        birthDate: birthDate.value,
        ageGroup: ageGroup.value,
        coat_pattern: coat_pattern.value,
        color: color.value,
      };

      if (selectedCategory.value.name === 'Cats' || selectedCategory.value.name === 'Dogs') {
        docData.isNeutered = isNeutered.value;
        docData.isMicrochipped = isMicrochipped.value;
        docData.isVaccinated = isVaccinated.value;
        docData.isWormTreated = isWormTreated.value;
        docData.isHealthChecked = isHealthChecked.value;
        docData.bloodType = bloodType.value;
        docData.gender = gender.value;
        docData.certificate = certificate.value;
      }

      console.log("Firestore'a gönderilecek images:", validImages);
      console.log("Firestore'a gönderilecek thumbnails:", validThumbnails);

      // Firestore'u güncelle
      await updatePetListing(documentId.value, docData);
      await createSlug(title.value, documentId.value);

      // localStorage'ı temizle
      localStorage.removeItem(`petform_${auth.currentUser.uid}`);
      router.push({ path: '/profile', query: { tab: 'myListing' } });
    } catch (err) {
      console.error('İlan eklenirken hata oluştu:', err);
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  const authLoading = ref(true);

  const handleGenderChange = (value) => {
    gender.value = value;
  };
  const handleAdTypeChange = (value) => {
    adType.value = value;
  };

  const documentId = ref(null); // Oluşturulan dökümanın ID'sini tutmak için
  const currentStep = ref(1); // Hangi adımda olduğumuzu takip etmek için

  // Removed old watch on documentId and images

  // Kategori seçimi tamamlandığında veya ilk resim yüklendiğinde ilk dökümanı oluştur
  const createInitialDocument = async () => {
    if (!documentId.value) {
      try {
        const docData = {
          createdAt: serverTimestamp(),
          createdBy: auth.currentUser.uid,
          owner: auth.currentUser.email,
          status: 'draft',
        };
        
        if (selectedCategory.value?.name) docData.category = selectedCategory.value.name;
        if (selectedCategory.value?.id) docData.categoryId = selectedCategory.value.id;
        if (selectedSubCategory.value) docData.subCategory = selectedSubCategory.value;

        const docRef = await createPetListing(docData);
        documentId.value = docRef.id;
      } catch (err) {
        error.value = 'Draft oluşturulamadı: ' + err.message;
      }
    }
  };

  const uploadImageImmediately = async (mainFile, thumbnailFile, imageObj) => {
    try {
      // 1. ÖNCE AI KONTROLÜ (GÜVENLİK VE TÜR TAHMİNİ)
      try {
        const categoriesMap = {};
        const categoriesDetails = {};
        categories.value.forEach(cat => {
          categoriesMap[cat.name] = cat.subcategories;
          categoriesDetails[cat.name] = {
            breeds: cat.subcategories || [],
            coat_patterns: cat.coat_patterns || [],
            colors: cat.colors || []
          };
        });
        
        const reader = new FileReader();
        const base64String = await new Promise((resolve, reject) => {
          reader.readAsDataURL(mainFile);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
        
        const result = await analyzePetImageFn({
          imageBase64: base64String,
          categoriesMap: categoriesMap,
          categoriesDetails: categoriesDetails
        });
        const { isSafe, reason, categoryGuess, breedGuess, coatPatternGuess, colorGuess, ageGroupGuess } = result.data;
        
        if (!isSafe) {
          // Güvensiz ise listenden çıkar ve işlemi sonlandır
          const idx = images.value.indexOf(imageObj);
          if (idx > -1) images.value.splice(idx, 1);
          
          aiWarningMessage.value = `Güvenlik İhlali (Resim reddedildi): ${reason}`;
          return;
        }
        
        imageObj.aiSuggestion = { 
          category: categoryGuess, 
          subCategory: breedGuess,
          coatPattern: coatPatternGuess,
          color: colorGuess,
          ageGroup: ageGroupGuess
        };
      } catch (aiErr) {
        console.error("AI Analiz hatası:", aiErr);
        // AI analizi çökse bile resmi kabul edelim mi? Evet, en azından form kilitlenmesin.
      }

      // 2. GÜVENLİ İSE STORAGE'A YÜKLE
      const mainUrl = await uploadImage(mainFile, `${documentId.value}`);
      const thumbnailUrl = await uploadImage(thumbnailFile, `${documentId.value}/thumbnails`);

      // URL'leri sakla
      imageObj.uploadUrl = mainUrl || '';
      imageObj.thumbnailUrl = thumbnailUrl || '';

      // 3. FIRESTORE (DB) GÜNCELLEMESİ
      const updateData = {};

      if (mainUrl) {
        updateData.images = arrayUnion(mainUrl);
      }

      if (thumbnailUrl) {
        updateData.thumbnails = arrayUnion(thumbnailUrl);
      }

      if (mainUrl && imageObj.aiSuggestion) {
        updateData.aiSuggestions = arrayUnion({
          url: mainUrl,
          category: imageObj.aiSuggestion.category || '',
          subCategory: imageObj.aiSuggestion.subCategory || '',
          coatPattern: imageObj.aiSuggestion.coatPattern || '',
          color: imageObj.aiSuggestion.color || '',
          ageGroup: imageObj.aiSuggestion.ageGroup || ''
        });
      }

      if (imageObj.isCover) {
        if (mainUrl) updateData.coverImage = mainUrl;
        if (thumbnailUrl) updateData.coverThumbnail = thumbnailUrl;
      }

      // Sadece veri varsa güncelle
      if (Object.keys(updateData).length > 0) {
        await updatePetListing(documentId.value, updateData);
      }

      // images dizisini güncelle
      const index = images.value.findIndex((img) => img === imageObj);
      if (index !== -1) {
        images.value[index] = {
          ...imageObj,
          uploading: false,
          uploadError: false,
        };
      }

      // LocalStorage'ı güncelle
      saveToLocalStorage();
    } catch (err) {
      console.error('Resim yükleme hatası:', err);
      imageObj.uploadError = true;
      error.value = err.message;
    } finally {
      imageObj.uploading = false;
    }
  };

  // Kategori değiştiğinde dökümanı güncelle
  watch([selectedCategory, selectedSubCategory], async ([newCat, newSubCat]) => {
    if (documentId.value && !isInitialLoad.value) {
      try {
        // console.log("Firestore güncelleniyor...");
        await updatePetListing(documentId.value, {
          category: newCat.name,
          categoryId: newCat.id,
          subCategory: newSubCat,
        });
        // console.log("Firestore başarıyla güncellendi");
      } catch (err) {
        console.error('Firestore güncelleme hatası:', err);
        error.value = err.message;
      }
    }
  });

  watch(documentId, (newVal) => {
    if (newVal) {
      images.value.forEach((image) => {
        // Eğer resim hala yüklenmediyse (yani uploadUrl girilmemişse) yüklemeyi başlat
        if (image.uploading && !image.uploadUrl && !image.uploadError) {
          uploadImageImmediately(image.file, image.thumbnail, image);
        }
      });
    }
  });

  const handleDragEnd = async () => {
    if (!auth.currentUser) return;

    try {
      // Tüm görsellerin URL'lerini kontrol et - ÖNEMLİ: URL değil uploadUrl kullanılmalı
      const validImages = images.value
        .map((img) => ({
          url: img.uploadUrl || '', // uploadUrl kullanıldığından emin ol
          thumbnailUrl: img.thumbnailUrl || '',
          isCover: img.isCover,
        }))
        .filter((img) => img.url);

      // LocalStorage'a kaydet
      const formData = {
        ...JSON.parse(localStorage.getItem(`petform_${auth.currentUser.uid}`) || '{}'),
        images: validImages,
      };

      localStorage.setItem(`petform_${auth.currentUser.uid}`, JSON.stringify(formData));

      // Ayrıca Firestore'u da güncelleyelim
      const updateData = {
        images: validImages.map((img) => img.url),
        thumbnails: validImages.map((img) => img.thumbnailUrl).filter(Boolean),
      };

      // Cover image'i güncelle
      const coverImg = validImages.find((img) => img.isCover);
      if (coverImg) {
        updateData.coverImage = coverImg.url;
        if (coverImg.thumbnailUrl) updateData.coverThumbnail = coverImg.thumbnailUrl;
      }

      await updatePetListing(documentId.value, updateData);

      // Cover index'ini güncelle
      coverImageIndex.value = images.value.findIndex((img) => img.isCover);
    } catch (err) {
      console.error('Resim sıralaması kaydedilirken hata:', err);
      error.value = 'Resim sıralaması kaydedilemedi: ' + err.message;
    }
  };


  const checkListingOwner = async () => {
    try {
      const listingDoc = await getPetListingById(documentId.value);
      if (listingDoc.exists()) {
        return listingDoc.data().createdBy;
      }
      return null;
    } catch (err) {
      console.error('İlan sahibi kontrolü hatası:', err);
      return null;
    }
  };

  const deleteImageFromStorage = async (url) => {
    try {
      const fileRef = storageRef(storage, url);
      await deleteObject(fileRef);
    } catch (error) {
      console.error('Storage silme hatası:', error);
    }
  };

  //end script
</script>

<style scoped>
  .fuzone {
    position: relative;
    border: 1px solid #eee;
    border-radius: 3px;
    background: #f7f9fb;
    transition: all 0.3s linear; /* 0.3slinear düzeltildi */
    margin-bottom: 10px;
    width: 100%;
    min-height: 160px;
    margin-top: 0px;
    float: left;
    cursor: pointer;
  }

  .fuzone .fu-text i {
    font-size: 44px;
    width: 100%;
    padding-bottom: 10px;
    transition: all 0.3s linear; /* 0.3slinear düzeltildi */
    color: #666;
  }
  .fuzone input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 100;
    cursor: pointer;
  }
  .custom-form input {
    margin-bottom: 20px;
  }
  .fuzone .fu-text i {
    font-size: 44px;
    width: 100%;
    padding-bottom: 10px;
    transition: all 0.3slinear;
    color: #666;
  }
  .spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 150px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .image-preview {
    margin-top: 1rem;
    width: 100%;
  }

  .image-item {
    position: relative;
  }

  .image-item img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
  }

  .cover-selected {
    background-color: #42b983;
    color: white;
  }

  .draggable-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }

  .draggable-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    width: 100%;
  }

  .image-item {
    cursor: move;
    transition: transform 0.2s;
    background: white;
    border-radius: 4px;
    padding: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .image-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .delete-button {
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: rgba(255, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 5;
  }

  .delete-button:hover {
    background-color: rgba(255, 0, 0, 1);
    transform: scale(1.1);
  }

  .delete-button:disabled {
    background-color: rgba(150, 150, 150, 0.7);
    cursor: not-allowed;
  }
</style>
